import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/new-getqcall/htdocs/new.getqcall.com/getQCall/components/Form/Form.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/new-getqcall/htdocs/new.getqcall.com/getQCall/components/ScrollFadeIn.js");
;
import(/* webpackMode: "eager" */ "/home/new-getqcall/htdocs/new.getqcall.com/getQCall/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/new-getqcall/htdocs/new.getqcall.com/getQCall/public/icon/face.svg");
;
import(/* webpackMode: "eager" */ "/home/new-getqcall/htdocs/new.getqcall.com/getQCall/public/icon/insta.svg");
;
import(/* webpackMode: "eager" */ "/home/new-getqcall/htdocs/new.getqcall.com/getQCall/public/icon/link.svg");
;
import(/* webpackMode: "eager" */ "/home/new-getqcall/htdocs/new.getqcall.com/getQCall/public/icon/mail.svg");
;
import(/* webpackMode: "eager" */ "/home/new-getqcall/htdocs/new.getqcall.com/getQCall/public/icon/phone.svg");
;
import(/* webpackMode: "eager" */ "/home/new-getqcall/htdocs/new.getqcall.com/getQCall/public/icon/pin.svg");
;
import(/* webpackMode: "eager" */ "/home/new-getqcall/htdocs/new.getqcall.com/getQCall/public/icon/wp.svg");
;
import(/* webpackMode: "eager" */ "/home/new-getqcall/htdocs/new.getqcall.com/getQCall/public/icon/youtube.svg");
